import randomColor from 'randomcolor';
import { IRemoteUser } from '../types/content';

export default (user: IRemoteUser | null) => {
    // If anyone is inside BTag offices or using VPN and logged in as a non-bananatag email,
    // the colors will be replaced to represent a bananatag employee.
    const shouldDisplayBananaTagColors = user?.isIPFromBananaTagOffice && !user?.email.includes('@bananatag');
    let colors;

    if (shouldDisplayBananaTagColors) {
        colors = {
            avatarBackgroundColor: '#402252',
            avatarBorderColor: '#402252',
            overlayBackgroundColor: 'rgba(255, 206, 0, 0.7)',
            overlayBorderColor: '#FFCE00',
            overlayWaveColor: '#76369E',
            overlayTextBackgroundColor: '#FFFFFF',
            overlayTextColor: '#76369E',
        };
    } else {
        const primaryColor = randomColor({ seed: user?.email, luminosity: 'bright', format: 'rgba', alpha: 0.7 });
        const secondaryColor = randomColor({ seed: user?.email, luminosity: 'light', format: 'rgba', alpha: 0.5 });
        const tertiaryColor = randomColor({ seed: user?.email, luminosity: 'light', format: 'rgba', alpha: 0.9 });

        colors = {
            avatarBackgroundColor: secondaryColor,
            avatarBorderColor: primaryColor,
            overlayBackgroundColor: secondaryColor,
            overlayBorderColor: primaryColor,
            overlayWaveColor: primaryColor,
            overlayTextBackgroundColor: tertiaryColor,
            overlayTextColor: '#26455E',
        };
    }

    return colors;
};
